module.exports = __webpack_public_path__ + "img/No Notification Icon.f8bbb697.svg";